export default {
  // Endpoints
  loginEndpoint: '/base/api/Authentication/v1/generateToken',
  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/base/api/Authentication/v1/refreshToken',
  logoutEndpoint: '/jwt/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
  storageUserEmail: 'email',
  storageUserPermission: 'permission',
}
